var _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderProperty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e0e0e0",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#bgGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0 L100 50 L0 50 Z",
    fill: "#c0c0c0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 80,
    height: 60,
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 20,
    height: 40,
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 60,
    width: 15,
    height: 15,
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 60,
    width: 15,
    height: 15,
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 20,
    width: 15,
    height: 30,
    fill: "#b0b0b0"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 220,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#888888",
    textAnchor: "middle"
  }, "Imagen no disponible")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 240,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#aaaaaa",
    textAnchor: "middle"
  }, "AMPI Riviera Nayarit")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderProperty);
export default __webpack_public_path__ + "static/media/placeholder-property.7de1a44ac25b68fbbc025cbb3f09a986.svg";
export { ForwardRef as ReactComponent };